import { render, staticRenderFns } from "./CreateOrderButton.vue?vue&type=template&id=b3e6aace"
import script from "./CreateOrderButton.vue?vue&type=script&lang=js"
export * from "./CreateOrderButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports